import { UrlsAPI } from '@cheerfy/lib';
import { Page } from '../pages/page';
import { CommonResponse } from '../shared/types/backend/pay-response.type';

export const findTable = (tableName: string) => {
    const payResponse = Page.getPayResponse<CommonResponse>();

    if (!payResponse?.pay_configuration?.settings?.configuration?.tables?.length) {
        return undefined;
    }

    const { tables } = payResponse.pay_configuration.settings.configuration;

    return tables.find((table) => table.name.trim().toLowerCase() === tableName.trim().toLowerCase());
};

export const getTableUrl = (tableName: string, link: URL) => {
    const payResponse = Page.getPayResponse<CommonResponse>();
    const table = findTable(tableName);

    const replacedParams: Record<string, string> = {};

    if (payResponse?.pay_configuration?.settings?.configuration?.payment_method?.is_pay_later_enabled
        && table?.options?.order_skip_checkout
        && table?.options?.engine_pay_later
    ) {
        replacedParams['skip_checkout'] = 'true';
    }

    replacedParams['table_id'] = tableName;

    // @ts-ignore
    if (window.CookiesManagement && CookiesManagement.isReady()) {
        // @ts-ignore
        const serializedCCC = window.CookiesManagement.serialize();

        replacedParams['ccc'] = serializedCCC.ccc;
    }

    return UrlsAPI.replaceParameters(link, replacedParams);
};
